// Replacing a unit's contents without replacing the object itself.
//
// The page, the editor and the mounted toolboxes all hold a reference to the
// same unit object, and the unsaved-changes guard pins itself to that object by
// identity. Anything that would swap in a new one — restoring an undo snapshot,
// adopting the server's copy after a save — has to write into the existing
// object instead of rebinding it, or those holders are left editing an orphaned
// copy and the guard stops reporting.
export function replaceInPlace(target, source) {
    if (!target || !source)
        return target;

    // Drop keys the new state does not have, so this is a replacement rather
    // than a merge that leaves stale fields behind.
    Object.keys(target).forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(source, key))
            delete target[key];
    });

    return Object.assign(target, source);
}

export default {replaceInPlace: replaceInPlace};
